/** @jsx jsx */
import { jsx } from "@emotion/core";
import PropTypes from "prop-types";
import { stylegun } from "@dgraph-io/typhoon-ui";
import { theme } from "@dgraph-io/typhoon-ui";
import { Link } from "react-router-dom";
import { styles } from "./AppLink.styles";

const AppLink = ({ children, styles: stylesProp = {}, ...props }) => {
    return (
        <Link
            css={stylegun({
                css: {
                    ...styles.AppLink,
                    ":focus-visible": styles.focusStyles,
                    ...stylesProp,
                },
                theme,
            })}
            {...props}
        >
            {children}
        </Link>
    );
};

AppLink.propTypes = {
    styles: PropTypes.object,
    theme: PropTypes.object,
    children: PropTypes.any,
};

export default AppLink;
